/**
 * Created by ori on 28/07/16.
 */
'use strict';
import React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';

@observer(['state','actions'])
export default class Signup extends Component {
    render() {
        const signUI = this.props.state.ui.signup;
        const thankYou = <div>Thank you!</div>;
        const form = <div>
            <div className="error">{signUI.error}</div>
            Email:<input type="email" onChange={e => signUI.email = e.target.value}
                         value={signUI.email}/>
            Password:<input type="password" onChange={e => signUI.password = e.target.value}
                            value={signUI.password}/>
            Confirmation:<input type="password" onChange={e => signUI.confirmPassword = e.target.value}
                                value={signUI.confirmPassword}/>
            <button type="button" onClick={() => this.props.actions.auth.register()}>Register</button>
        </div>;

        return signUI.signedUp ? thankYou : form;
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/Signup.js